/* Three Nails restock notify (first-party Klaviyo back in stock).
   Pairs with snippets/restock-notify.liquid. The widget + variant data render
   server side inside the product section, so AJAX color swaps (separate
   products per color) always carry a fresh widget. All listeners are
   delegated on document; nothing needs re-initializing after a swap.
   The trigger shares the ATC slot: [data-restock-atc] (the real ATC wrap)
   and [data-restock-trigger] are toggled so exactly one is visible. */
(function () {
  var REVISION = '2024-10-15';

  function scopeFor(widget) {
    return widget.closest('.shopify-section--main-product') || widget.closest('.shopify-section') || document;
  }

  function readVariants(widget) {
    if (widget.__rnVariants) return widget.__rnVariants;
    var el = widget.querySelector('[data-restock-variants]');
    if (!el) return [];
    try { widget.__rnVariants = JSON.parse(el.textContent); } catch (e) { widget.__rnVariants = []; }
    return widget.__rnVariants;
  }

  function currentVariant(widget) {
    var scope = scopeFor(widget);
    var variants = readVariants(widget);
    if (!variants.length) return null;

    var picked = [];
    var i = 1;
    var radio;
    while ((radio = scope.querySelector('input[type="radio"][name="option' + i + '"]:checked'))) {
      picked.push(radio.value);
      i++;
    }

    if (picked.length) {
      for (var v = 0; v < variants.length; v++) {
        var match = true;
        for (var j = 0; j < picked.length; j++) {
          if (String(variants[v].options[j] || '') !== String(picked[j] || '')) { match = false; break; }
        }
        if (match) return variants[v];
      }
    }

    var idInput = scope.querySelector('form[is="product-form"] input[name="id"]');
    if (idInput && idInput.value) {
      for (var k = 0; k < variants.length; k++) {
        if (String(variants[k].id) === String(idInput.value)) return variants[k];
      }
    }

    return null;
  }

  /* One visible button in the ATC slot: sold out -> notify trigger, else ATC. */
  function refreshSlot(widget) {
    var variant = currentVariant(widget);
    widget.__rnSelected = variant;

    var soldOut = !!(variant && variant.available === false);
    var trigger = widget.querySelector('[data-restock-trigger]');
    var atcWrap = scopeFor(widget).querySelector('[data-restock-atc]');

    if (trigger) trigger.hidden = !soldOut;
    if (atcWrap) atcWrap.hidden = soldOut;
  }

  function refreshAll() {
    document.querySelectorAll('[data-restock]').forEach(refreshSlot);
  }

  /* The widget renders inside the product section, where ancestor transforms
     trap position:fixed and let the header paint over the modal. Portal the
     overlay to <body> on first open; keep a back-reference for submit. */
  function overlayFor(widget) {
    if (widget.__rnOverlay && document.body.contains(widget.__rnOverlay)) return widget.__rnOverlay;
    var overlay = widget.querySelector('[data-restock-modal]');
    if (overlay) {
      document.querySelectorAll('body > [data-restock-modal]').forEach(function (o) { o.remove(); });
      document.body.appendChild(overlay);
      overlay.__rnWidget = widget;
      widget.__rnOverlay = overlay;
    }
    return overlay;
  }

  function widgetForNode(node) {
    var overlay = node.closest('[data-restock-modal]');
    if (overlay && overlay.__rnWidget) return overlay.__rnWidget;
    return node.closest('[data-restock]');
  }

  function openPanel(widget) {
    refreshSlot(widget);
    var variant = widget.__rnSelected;
    var overlay = overlayFor(widget);
    if (!overlay || !variant) return;

    var label = overlay.querySelector('[data-restock-variant-label]');
    if (label) {
      var names = [];
      try { names = JSON.parse(widget.getAttribute('data-restock-option-names') || '[]'); } catch (e) {}
      var parts = [];
      for (var n = 0; n < variant.options.length; n++) {
        parts.push(names[n] ? names[n] + ': ' + variant.options[n] : variant.options[n]);
      }
      label.textContent = parts.length ? parts.join(' \u00b7 ') : (variant.title || '');
    }

    var formStep = overlay.querySelector('[data-restock-step="form"]');
    var doneStep = overlay.querySelector('[data-restock-step="success"]');
    if (formStep) formStep.hidden = false;
    if (doneStep) doneStep.hidden = true;

    var err = overlay.querySelector('[data-restock-error]');
    if (err) err.hidden = true;

    overlay.hidden = false;
    document.documentElement.classList.add('tn-restock-open');

    var email = overlay.querySelector('[data-restock-email]');
    if (email) setTimeout(function () { email.focus(); }, 50);
  }

  function closePanel(overlay) {
    overlay.hidden = true;
    document.documentElement.classList.remove('tn-restock-open');
  }

  function subscribe(widget) {
    if (!widget) return;
    var overlay = widget.__rnOverlay || widget.querySelector('[data-restock-modal]');
    if (!overlay) return;

    var variant = widget.__rnSelected;
    var emailInput = overlay.querySelector('[data-restock-email]');
    var err = overlay.querySelector('[data-restock-error]');
    var btn = overlay.querySelector('[data-restock-submit]');
    var email = ((emailInput && emailInput.value) || '').trim();

    if (!variant) return;

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (err) { err.textContent = 'Enter a valid email address.'; err.hidden = false; }
      return;
    }

    if (err) err.hidden = true;
    if (btn) { btn.disabled = true; btn.__rnLabel = btn.textContent; btn.textContent = 'Sending...'; }

    var account = widget.getAttribute('data-restock-account');

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(account), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': REVISION },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant.id } }
          }
        }
      })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.text().then(function (t) { throw new Error(t || String(res.status)); });
        }
        var formStep = overlay.querySelector('[data-restock-step="form"]');
        var doneStep = overlay.querySelector('[data-restock-step="success"]');
        if (formStep) formStep.hidden = true;
        if (doneStep) doneStep.hidden = false;
      })
      .catch(function () {
        if (err) { err.textContent = 'Something went wrong. Try again.'; err.hidden = false; }
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.__rnLabel || 'Notify Me'; }
      });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-restock-trigger]');
    if (trigger) {
      e.preventDefault();
      openPanel(trigger.closest('[data-restock]'));
      return;
    }

    var closeEl = e.target.closest('[data-restock-close]');
    if (closeEl) {
      var overlay = closeEl.closest('[data-restock-modal]');
      if (overlay) closePanel(overlay);
      return;
    }

    var submitBtn = e.target.closest('[data-restock-submit]');
    if (submitBtn) {
      e.preventDefault();
      subscribe(widgetForNode(submitBtn));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('[data-restock-modal]:not([hidden])');
      if (open) closePanel(open);
      return;
    }
    if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('[data-restock-email]')) {
      e.preventDefault();
      subscribe(widgetForNode(e.target));
    }
  });

  /* Size switches within the product: refresh after the theme processes it. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('input[type="radio"][name^="option"]')) return;
    setTimeout(refreshAll, 0);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }

  /* AJAX color swaps replace the product section wholesale; sync when a new
     widget lands. */
  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if ((node.matches && node.matches('[data-restock]')) || (node.querySelector && node.querySelector('[data-restock]'))) {
          setTimeout(refreshAll, 0);
          return;
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
